enum ActionType {
    SetTitle = 'Quiz.SET_TITLE',
    SetQuestions = 'Quiz.SET_QUESTIONS',
    SetQuizIds = 'Quiz.SET_QUIZ_IDS',
    SetStorage = 'Quiz.SET_STORAGE',
    SetStorageIndex = 'Quiz.SET_STORAGE_INDEX',
}

export default ActionType;
